import { BaseCellElement } from './baseCellElement';
import { UIElement } from '../uiElements';
import { IBaseUIElementOptions } from '../../../interfaces/options';
import { CellElementType } from '../../../enums';
import { ID } from '../../../const';

export class LabelCellElement extends BaseCellElement {
	private _label: KnockoutObservable<string>;
	private label: KnockoutComputed<string>;
	private base: UIElement<any>;

	constructor(
		base: UIElement<any>,
		label: string,
		editable: KnockoutObservable<boolean>,
		options: IBaseUIElementOptions
	) {
		super(options.size, CellElementType.LABEL, editable, options.template);

		this.base = base;
		this._label = ko.observable<string>(label);
		this.label = ko.pureComputed<string>(() => {
			return this._label().concat(this.base.isRequired() ? ID.IsRequiredSymbol : '');
		});
	}

	public change(label: string) {
		this._label(label);
	}
}
